module.exports = __webpack_public_path__ + "img/lpe.5dd8a9b5.jpg";